// URLS
import {
  getPoiNames,
  getPoisOnMap,
  getV2PoiHirarchyUrl,
  getPoiHirarchyUrl,
  getV2BrandInfo,
  getV2SectorInfo,
} from "../urls/PoiURL";

// Constants and Utils
import bang from "../utils/bang.json";
import { sendGetRequest } from "../utils/api/apiUtils";

// PoiTypes Hiding List
// "Colleges" and "Universities" are combined as new poiType => "Colleges & Universities"
// "Shopping Malls" data updated => hide "Shopping Centres" and "Malls"
const POI_TYPES_TO_HIDE = [
  "Colleges",
  "Universities",
  "Shopping Centres",
  "Malls",
];

export async function getPoiBrandData(cityId, brandId) {
  const useV2Data = process.env.REACT_APP_USE_V2_MAP_VIEW;
  if (useV2Data) {
    const v2BrandInfoUrl = getV2BrandInfo
      .replace(":cityId", cityId)
      .replace(":brandId", brandId);

    const brandInfo = await sendGetRequest(v2BrandInfoUrl);
    return brandInfo.result;
  }
  return bang.result;
}

export async function getPoiSectorData(cityId, sectorId) {
  const useV2Data = process.env.REACT_APP_USE_V2_MAP_VIEW;
  if (useV2Data) {
    const v2SectorInfoUrl = getV2SectorInfo
      .replace(":cityId", cityId)
      .replace(":sectorId", sectorId);

    const sectorInfo = await sendGetRequest(v2SectorInfoUrl);
    return sectorInfo.result;
  }
  return bang.result;
}

// normalize text
function normalizeName(value) {
  if (!value) {
    return "";
  }

  // trim and lowercase the value
  const trimmedLowercaseValue = value.trim().toLowerCase();

  const normalizedValue = trimmedLowercaseValue
    .replace(/[^a-z0-9\s]/g, "") // remove special char but keep spaces
    .replace(/\b(\w+)s\b/g, "$1") // remove plural "s" from words
    .replace(/\s+/g, ""); // finally remove spaces

  return normalizedValue;
}

function restructureV2Data(v2Data) {
  const v3Data = {};
  const poiTypeTrees = [];
  const brandsByPoiType = {};

  Object.entries(v2Data.result).forEach(([sector, brands]) => {
    // Hide specific POITypes from the hierarchy
    if (POI_TYPES_TO_HIDE.includes(sector)) {
      return;
    }

    // update poiTypeTrees and brandsByPoiType
    poiTypeTrees.push({ id: sector, name: sector, children: [] });

    // Ensure any "Others" or "others" brand appears at the end of the list
    const othersSortedBrands = [...brands].sort((a, b) => {
      const isAOthers = a.toLowerCase().startsWith("others");
      const isBOthers = b.toLowerCase().startsWith("others");

      if (isAOthers) {
        return 1;
      }
      if (isBOthers) {
        return -1;
      }
      return 0;
    });

    // Map the brands to the required format and exclude the sector name if it appears as a brand
    const sectorChildren = othersSortedBrands
      .filter((eachBrand) => normalizeName(eachBrand) !== normalizeName(sector))
      .map((eachBrand) => ({
        id: eachBrand,
        name: eachBrand,
      }));

    brandsByPoiType[sector] = sectorChildren;
  });
  v3Data.brandsByPoiType = brandsByPoiType;
  v3Data.poiTypeTrees = poiTypeTrees;
  return v3Data;
}

export async function getPoiHierarchy(cityId) {
  const useV2Data = process.env.REACT_APP_USE_V2_MAP_VIEW;
  if (useV2Data) {
    const params = {
      city: cityId,
    };
    const response = await sendGetRequest(getV2PoiHirarchyUrl, params);
    return restructureV2Data(response);
  }

  return sendGetRequest(getPoiHirarchyUrl);
}

export async function getPoiData(inputText, pn, ps) {
  const headerParams = {
    "Content-Type": "application/json",
  };

  const params = {
    pn: pn,
    ps: ps,
    _kw: inputText,
  };

  const url = getPoiNames;
  return sendGetRequest(url, params, true, headerParams);
}

export async function getPoisOnMapView(poiType, cityId) {
  const headerParams = {
    "Content-Type": "application/json",
  };
  return sendGetRequest(
    getPoisOnMap.replace(":cityId", cityId).replace(":poiType", poiType),
    {},
    true,
    headerParams
  );
}
